var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,21.5C3,21.5,3,21.5,3,21.5c-0.3,0-0.5-0.2-0.5-0.5l0-0.2c-0.2-5.4,2.5-10.7,7.9-15L9.2,3.2C9.1,3,9.2,2.8,9.3,2.7 c0.1-0.1,0.3-0.2,0.4-0.2L21,3.2c0.2,0,0.3,0.1,0.4,0.3s0.1,0.4,0,0.5l-6.3,9.4c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.4-0.3 l-1.4-2.7c-7.3,3-9.1,9.7-9.3,10.5C3.5,21.4,3.3,21.5,3,21.5z M10.4,3.5l1,2.4c0.1,0.2,0,0.5-0.2,0.6c-4.2,3.3-6.8,7.2-7.6,11.3 c1.3-2.7,4-6.3,9.1-8.3c0.2-0.1,0.5,0,0.6,0.2l1.2,2.4l5.3-8L10.4,3.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.59f5601f04eb2c7116b082396071cd57.svg";
export { ForwardRef as ReactComponent };